module.exports = __webpack_public_path__ + "media/images/login/demo-111c0b438843fcce1be7d0a4ba0afcb4.jpg";